import type { ComponentProps } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';
import { adaptiveFrostedActionSurface } from '@/src/components/ui/FrostedActionSurface/frostedActionSurface.styles';
import { frostedToggleButtonGroupStyles, frostedToggleButtonStyles } from './frostedToggleButtonGroup.recipe';

type Props = Omit<ComponentProps<typeof ToggleButtonGroup>, 'className' | 'conjoined' | 'css'>;
type ToggleProps = ComponentProps<typeof ToggleButton>;

export function FrostedToggleButtonGroup({ role = 'group', ...props }: Props) {
  return (
    <ToggleButtonGroup
      {...props}
      conjoined={false}
      role={role}
      className={adaptiveFrostedActionSurface}
      css={frostedToggleButtonGroupStyles}
    />
  );
}

export function FrostedToggleButton({ css, ...props }: ToggleProps) {
  return <ToggleButton {...props} css={{ ...frostedToggleButtonStyles, ...css }} />;
}
